const allowedCharsOnly = (value: string): boolean =>
  /^[A-Za-zÀ-ÖØ-ßà-öø-ÿ0-9.,#"'\- ]+$/.test(value);

export const notEmpty = (value: string): boolean => Boolean(value?.trim());

export const present = (value: string): boolean =>
  notEmpty(value) && allowedCharsOnly(value);
